import { captureError } from "@capraconsulting/sentry-utils-js";

const MONTHS = [
  "januar",
  "februar",
  "mars",
  "april",
  "mai",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "desember",
];

export enum DatetimeFormat {
  SHORT = "SHORT",
  MEDIUM = "MEDIUM",
  LONG = "LONG",
}

function convertToDate(value: string): Date {
  try {
    return new Date(value);
  } catch (err) {
    captureError("Could not parse value to date", { value });
    throw err;
  }
}

function padWithZero(value: number): string {
  return value < 10 ? `0${value}` : "" + value;
}

export const formatAsDate = (
  value: string,
  format: DatetimeFormat = DatetimeFormat.LONG
): string => {
  const dateObj = convertToDate(value);

  const date = dateObj.getDate();
  const month = dateObj.getMonth();
  const year = dateObj.getFullYear();

  if (format === DatetimeFormat.SHORT) {
    return `${date}.${month + 1}.`;
  } else if (format === DatetimeFormat.MEDIUM) {
    return `${padWithZero(date)}.${padWithZero(month + 1)}.${year
      .toString()
      .substring(2, 4)}`;
  } else if (format === DatetimeFormat.LONG) {
    return `${date}. ${MONTHS[month]} ${year}`;
  } else {
    captureError("Invalid datetime format", { format, value });
    return value;
  }
};

export const formatAsTime = (
  value: string,
  format: DatetimeFormat = DatetimeFormat.LONG
): string => {
  const dateObj = convertToDate(value);

  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  if (format === DatetimeFormat.SHORT) {
    return `kl. ${hours}.${padWithZero(minutes)}`;
  } else if (
    format === DatetimeFormat.MEDIUM ||
    format === DatetimeFormat.LONG
  ) {
    return `kl. ${padWithZero(hours)}.${padWithZero(minutes)}`;
  } else {
    captureError("Invalid datetime format", { format, value });
    return value;
  }
};

export const formatAsDatetime = (
  value: string,
  format: DatetimeFormat = DatetimeFormat.LONG
): string => {
  return `${formatAsDate(value, format)} ${formatAsTime(value, format)}`;
};
